import loadable from '@loadable/component';
import React from 'react';
import {TouchableOpacity} from 'react-native';
import styles from './FabBackButton.style';
const SVG = loadable(() => import('../../imports/svg'));

const FabBackButton = props => {
  const {container_style, icon, iconSize} = props;
  return (
    <TouchableOpacity style={[styles.container, container_style]} {...props}>
      <SVG
        name={icon ?? 'backIcon'}
        width={iconSize ?? 12}
        height={iconSize ?? 12}
      />
    </TouchableOpacity>
  );
};
export default FabBackButton;
